export type MCardV2Props = {
  ariaLabel?: string;
  title: string;
  contentPadding?: boolean;
};

export const MCardV2Defaults: Partial<MCardV2Props> = {
  ariaLabel: undefined,
  contentPadding: false,
};
